module.exports = __webpack_public_path__ + "img/sjaakfeest.f9fa8ae1.jpg";